import {Heading, Pane} from "evergreen-ui";
import React from "react";
import {ClientManagementLayout} from "../../layouts/ClientManagementLayout";
import {PORTAL_NAVY} from "../../../common";
import {ExportAuditLogTable} from "./ExportAuditLogTable";


export const ExportAuditLogPage = () => (
    <ClientManagementLayout customSelection={'Audit Export'}>
        <Pane className="m-5 p-5 bg-white shadow-md rounded flex flex-col" flexGrow={1}
              minHeight="calc(100vh - 100px - 260px - 36px)">
            <Heading size={700} color={PORTAL_NAVY} marginBottom={24}>Export Audit Log</Heading>
            <ExportAuditLogTable/>
        </Pane>
    </ClientManagementLayout>
);
